import { render } from "./AccomodationCard.vue?vue&type=template&id=b3ba715c"
import script from "./AccomodationCard.vue?vue&type=script&lang=js"
export * from "./AccomodationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__